/* GENERATED FROM base.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

export interface ReqHdr {
  tid?: string
}

export interface RespHdr {
  tid?: string
  req_tid?: string
}

export interface AccountInfo {
  account_id?: string
  cloud_type?: CloudTypeEnum
  azureInfo?: AzureInfo
  status?: AccountStatusEnum
  account_name?: string
  tags?: AccountInfo_TagsEntry
  status_reason?: string
  usage_onboarding_done?: boolean
  cloud_trail_arn?: string
  aI_onboarding_done?: boolean
  not_configurable?: boolean
  parent_account_id?: string
  gcp_info?: GCPAccountInfo
  aws_info?: AWSInfo
  uid?: string
  legacy?: boolean
  parent_uid?: string
  okta_info?: OktaInfo
  root_uid?: string
  is_organization_account?: boolean
  usage_graph_updating_done?: boolean
  inventory_info?: AccountInventoryInfo
}

export interface AccountInfo_TagsEntry {
  [key: string]: string
}

export interface AccountInventoryInfo {
  identities?: number
  resources?: number
}

export interface OktaInfo {
  org_url?: string
  token?: string
  application_id?: string
  application_type?: CloudTypeEnum
  entity_id?: string
}

export interface AWSInfo {
  role_arn?: string
  external_id?: string
  is_root?: boolean
  is_organizational_trail?: boolean
  s3_object_support?: boolean
  s3_maximum_object_support?: number
  sns_topic_arn?: string
  cloud_trail_bucket_arn?: string
  cloud_trail_arn?: string
  organization_id?: string
  master_account_id?: string
  ct_log_archive_account_id?: string
}

export interface AzureInfo {
  tenant_id?: string
  app_client_id?: string
  app_secret?: string
  app_instance_id?: string
  cloud_type?: CloudTypeEnum
  is_shared?: boolean
}

export interface GCPAccountInfo {
  gcp_json_file_text?: string
  domain?: string
  organization_id?: string
  admin_email?: string
  project_id?: string
  project_number?: string
}

export interface AccountStatus {
  account_info?: AccountInfo
  status?: string
  internal_error?: string
}

export interface PolicyDetails {
  policy_name?: string
  policy_document?: string
  policy_uri?: string
}

export interface CommonInfo {
  Id?: string
  ResourceType?: string
  name?: string
  tags?: CommonInfo_TagsEntry
  modified?: boolean
  NativeID?: string
  Service?: string
}

export interface CommonInfo_TagsEntry {
  [key: string]: string
}

export interface permissions {
  actions?: string[]
  not_actions?: string[]
}

export interface ResourceInfo {
  resource_name?: string
  resource_num?: number
  identity_type?: boolean
  object_type?: boolean
  colorHash?: string
  imageHash?: string
  display_name?: string
  meta_label?: string
  network_type?: boolean
}

export interface UpdateAccountReq {
  req_hdr?: ReqHdr
  tenant_id?: string
  add_account_ids?: string[]
  delete_account_ids?: string[]
}

export interface SubOrganizationInfo {
  suborganization_name?: string
  suborganization_id?: string
  parent_id?: string
  sub_organization?: SubOrganizationInfo[]
  account_info?: AccountInfo[]
  suborganization_uid?: string
  parent_uid?: string
}

export interface OrganizationInfo {
  organization_name?: string
  organization_id?: string
  cloud_type?: CloudTypeEnum
  status?: OrganizationStatusEnum
  internal_error?: string
  aws_organization_info?: AWSInfo
  azure_organization_info?: AzureInfo
  gcp_organization_info?: GCPAccountInfo
  sub_organization?: SubOrganizationInfo[]
  account_info?: AccountInfo[]
  include_account_id_list?: OrganizationInfo_IncludeAccountIdListEntry
  organization_uid?: string
  inventory_info?: OrganizationInventoryInfo
}

export interface OrganizationInfo_IncludeAccountIdListEntry {
  [key: string]: boolean
}

export interface OrganizationInventoryInfo {
  identities?: number
  resources?: number
  folders?: number
  projects?: number
}

export interface ScopeInfo {
  common_info?: CommonInfo
  scopeInfo?: ScopeInfo[]
}

export enum CloudTypeEnum {
  CLOUD_TYPE_UNKNOWN = 'CLOUD_TYPE_UNKNOWN',
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP',
  IDP_AZURE_AD = 'IDP_AZURE_AD',
  IDP_OKTA = 'IDP_OKTA'
}

export enum AccountStatusEnum {
  ACCOUNT_STATUS_UNKNOWN = 'ACCOUNT_STATUS_UNKNOWN',
  ACCOUNT_STATUS_SUCCESS = 'ACCOUNT_STATUS_SUCCESS',
  ACCOUNT_STATUS_WARNING = 'ACCOUNT_STATUS_WARNING',
  ACCOUNT_STATUS_ERROR = 'ACCOUNT_STATUS_ERROR'
}

export enum OrganizationStatusEnum {
  ORGANIZATION_STATUS_UNKNOWN = 'ORGANIZATION_STATUS_UNKNOWN',
  ORGANIZATION_STATUS_SUCCESS = 'ORGANIZATION_STATUS_SUCCESS',
  ORGANIZATION_STATUS_WARNING = 'ORGANIZATION_STATUS_WARNING',
  ORGANIZATION_STATUS_ERROR = 'ORGANIZATION_STATUS_ERROR'
}

export enum ValidateTypeEnum {
  VALIDATE_TYPE_UNKNOWN = 'VALIDATE_TYPE_UNKNOWN',
  VALIDATE_TYPE_ORGANIZATION = 'VALIDATE_TYPE_ORGANIZATION',
  VALIDATE_TYPE_ACCOUNT = 'VALIDATE_TYPE_ACCOUNT'
}

export enum OrderByEnum {
  DESC = 'DESC',
  ASC = 'ASC'
}

export enum ServerPagingDirection {
  SERVER_PAGING_DIRECTION_UNKNOWN = 'SERVER_PAGING_DIRECTION_UNKNOWN',
  SERVER_PAGING_DIRECTION_NEXT = 'SERVER_PAGING_DIRECTION_NEXT',
  SERVER_PAGING_DIRECTION_PREVIOUS = 'SERVER_PAGING_DIRECTION_PREVIOUS'
}
